import React, { useEffect, useState } from "react";
import EditMarkasCompletePresenter from "./EditMarkasCompletePresenter";
import DTOEditMarkasComplete from "./DTOEditMarkasComplete";
import _ from "lodash";
import { trainingServices } from "../../../../api/services/trainingServices";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  editTraineesData: any;
}
const EditMarkasCompleteController = ({
  isModalOpen,
  closeModal,
  editTraineesData,
}: ModalInterface) => {
  const [state, setState] = useState<any>([]);
  const { t, i18n } = useTranslation();
  const handlePayload = async (data: any) => {
    const response: any = await trainingServices.updateMarkasComplete(data);
    if (response.response == "success") {
      toast.success(t("Updated Successfully"));
    }
  };
  useEffect(() => {
    console.log("kk");

    const loadEditData = async () => {
      const response = await trainingServices.getMarkasCompletedTraining(
        editTraineesData?.trainees[0].training_id
      );

      const loadtrainees: any = _.map(response.data, (data: any) => {
        console.log("vv--", data);

        const rowData: any = {
          id: data?.emp_id,
          empId: data?.emp_id,
          avatar: data?.employee?.user?.profile_pic,
          employee: data?.employee
            ? data?.employee?.first_name + " " + data?.employee?.last_name
            : "--",
          designation: data?.employee
            ? data?.employee?.emp_job_detail?.designation.name
            : "--",
          score: data?.score,
          status: data?.evaluation_status == 1 ? true : false,
          training_id: data?.training_id,
        };
        return rowData;
      });
      setState(loadtrainees);
    };

    loadEditData();
  }, [editTraineesData]);
  return (
    <>
      <DTOEditMarkasComplete />
      <EditMarkasCompletePresenter
        trans={t}
        i18n={i18n}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trainees_DataList={state}
        setPayload={handlePayload}
      />
    </>
  );
};
export default EditMarkasCompleteController;
